<div class="change-password-container">
  <div class="card">
    <div class="card-header text-center">
      <h2>Change Password</h2>
    </div>
    <div class="card-body">
      <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
        <!-- Success Message -->
        <div *ngIf="showSuccess" class="alert alert-success mb-3">
          <i class="bi bi-check-circle-fill me-2"></i>
          Your password has been changed successfully. You will be redirected to the main page in {{redirectCountdown}} seconds.
        </div>

        <!-- Error Message -->
        <div *ngIf="showError" class="alert alert-danger mb-3">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          <span [innerHTML]="errorMessage"></span>
        </div>

        <!-- Current Password -->
        <app-password-field
          label="Current Password"
          [control]="$any(changePasswordForm.get('currentPassword'))"
          [errorMessages]="{
            required: 'Current password is required',
            minlength: 'Password must be at least 8 characters',
            containsSpaces: 'Password cannot contain spaces'
          }"
          ngbTooltip="Enter your current password"
        ></app-password-field>

        <!-- New Password -->
        <app-password-field
          label="New Password"
          [control]="$any(changePasswordForm.get('newPassword'))"
          [errorMessages]="{
            required: 'New password is required',
            minlength: 'Password must be at least 8 characters',
            pattern: 'Password must contain uppercase letters, lowercase letters, numbers, and special characters',
            containsSpaces: 'Password cannot contain spaces'
          }"
          ngbTooltip="Password must meet all requirements"
        ></app-password-field>

        <!-- Confirm New Password -->
        <app-password-field
          label="Confirm New Password"
          [control]="$any(changePasswordForm.get('confirmNewPassword'))"
          [errorMessages]="{
            required: 'Please confirm your new password',
            mismatch: 'Passwords do not match',
            containsSpaces: 'Password cannot contain spaces',
            minlength: 'Password must be at least 8 characters',
            pattern: 'Password must contain uppercase letters, lowercase letters, numbers, and special characters',
          }"
          ngbTooltip="Re-enter your new password to confirm"
        ></app-password-field>

        <!-- Password Requirements -->
        <div class="password-requirements">
          <h6>Password Requirements</h6>
          <div class="row g-2">
            <div class="col-md-6">
              <div [ngClass]="{'text-success': hasMinLength()}">
                <i class="bi" [ngClass]="hasMinLength() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                At least 8 characters
              </div>
              <div [ngClass]="{'text-success': hasUpperCase()}">
                <i class="bi" [ngClass]="hasUpperCase() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One uppercase letter
              </div>
              <div [ngClass]="{'text-success': hasLowerCase()}">
                <i class="bi" [ngClass]="hasLowerCase() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One lowercase letter
              </div>
            </div>
            <div class="col-md-6">
              <div [ngClass]="{'text-success': hasNumber()}">
                <i class="bi" [ngClass]="hasNumber() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One number
              </div>
              <div [ngClass]="{'text-success': hasSpecialChar()}">
                <i class="bi" [ngClass]="hasSpecialChar() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One special character
              </div>
              <div [ngClass]="{'text-success': !hasError('confirmNewPassword', 'mismatch') && changePasswordForm.get('confirmNewPassword')?.value}">
                <i class="bi" [ngClass]="!hasError('confirmNewPassword', 'mismatch') && changePasswordForm.get('confirmNewPassword')?.value ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                Passwords match
              </div>
            </div>
          </div>
        </div>

        <div class="form-group text-center button-container">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="changePasswordForm.invalid"
          >
            Change Password
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
